var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 16,
      height: 18
    },
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0216 8.37473V3.2068H8.04416V8.37473L10.7867 6.09731L11.5096 6.69766L7.53288 10L3.55615 6.69766L4.2791 6.09731L7.0216 8.37473Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0216 16.3747V11.2068H8.04416V16.3747L10.7867 14.0973L11.5096 14.6977L7.53288 18L3.55615 14.6977L4.2791 14.0973L7.0216 16.3747Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.0005,
    y: 0.336914,
    width: 1.77778,
    height: 16,
    transform: "rotate(90 16.0005 0.336914)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopStack);
export default __webpack_public_path__ + "static/media/top_stack.2ec3addffadff751abf4c9574156e2b5.svg";
export { ForwardRef as ReactComponent };